var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny-ps",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 26",
    width: 32,
    height: 26,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Level 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\ttspan { white-space:pre }\n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Level 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Header"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041F\\u043E\\u0438\\u0441\\u043A 1",
    className: "shp0",
    d: "M31.71 25.26C31.23 25.95 30.26 26.12 29.55 25.65L23.17 21.33C22.72 21.02 22.44 23.04 22.48 21.86C20.59 23.89 18.11 25.25 15.33 25.76C11.92 26.38 8.47 25.64 5.62 23.67C2.78 21.69 0.86 18.73 0.24 15.31C-0.38 11.89 0.36 8.44 2.33 5.59C6.41 -0.3 14.51 -1.78 20.39 2.3C25.73 6 27.44 13.03 24.66 18.7C25.75 18.24 24.49 18.53 24.94 18.83L31.32 23.15C32.03 23.63 32.2 24.57 31.71 25.26ZM21.91 11.36C21.47 8.98 20.14 6.91 18.16 5.54C14.05 2.69 8.4 3.72 5.56 7.83C2.72 11.94 3.75 17.59 7.85 20.43C11.96 23.27 17.61 22.25 20.45 18.14C21.82 16.15 22.34 13.74 21.91 11.36Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.761a5271bba0025fbcc50e4d4a6ab670.svg";
export { ForwardRef as ReactComponent };